import {
  PERMISSION_LIST,
  SUPER_USER_CREATE,
  SUPER_USER_DELETE,
  SUPER_USER_DETAIL,
  SUPER_USER_EDIT,
  SUPER_USER_LIST,
  SUPER_USER_PERMISSION_LIST,
  SUPER_USER_VERSION_DETAIL,
  SUPER_USER_VERSION_LIST,
  SUPER_USER_ROLE_LIST,
  SUPER_USER_ROLE_PERMISSION_LIST,
  SUPER_USER_ROLE_DETAIL,
  SUPER_USER_ROLE_CREATE,
  SUPER_USER_ROLE_EDIT,
  SUPER_USER_ROLE_DELETE,
  SUPER_USER_ROLE_VERSION_LIST,
  SUPER_USER_ROLE_VERSION_DETAIL,
  PERMISSION_ROLE_LIST,
  ROLE_LIST
} from "./types";

export const superUserPermissionList = (onSuccess, onError) => {
  return {
    type: SUPER_USER_PERMISSION_LIST,
    onSuccess,
    onError,
  };
};

export const superUserList = (data, onSuccess, onError) => {
  return {
    type: SUPER_USER_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const superUserDetails = (id, onSuccess, onError) => {
  return {
    type: SUPER_USER_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const createSuperUser = (data, onSuccess, onError) => {
  return {
    type: SUPER_USER_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const updateSuperUser = (data, onSuccess, onError) => {
  return {
    type: SUPER_USER_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const deleteSuperUser = (id, onSuccess, onError) => {
  return {
    type: SUPER_USER_DELETE,
    id,
    onSuccess,
    onError,
  };
};

export const superUserVersionList = (data, onSuccess, onError) => {
  return {
    type: SUPER_USER_VERSION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const superUserVersionDetails = (id, onSuccess, onError) => {
  return {
    type: SUPER_USER_VERSION_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const permissionsList = (onSuccess, onError) => {
  return {
    type: PERMISSION_LIST,
    onSuccess,
    onError,
  };
};

// SUPERUSER-ROLE

export const superUserRoleList = (data, onSuccess, onError) => {
  return {
    type: SUPER_USER_ROLE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const superUserRoleDetails = (id, onSuccess, onError) => {
  return {
    type: SUPER_USER_ROLE_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const createSuperUserRole = (data, onSuccess, onError) => {
  return {
    type: SUPER_USER_ROLE_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const updateSuperUserRole = (data, onSuccess, onError) => {
  return {
    type: SUPER_USER_ROLE_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const deleteSuperUserRole = (id, onSuccess, onError) => {
  return {
    type: SUPER_USER_ROLE_DELETE,
    id,
    onSuccess,
    onError,
  };
};

export const superUserRoleVersionList = (data, onSuccess, onError) => {
  return {
    type: SUPER_USER_ROLE_VERSION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const superUserRoleVersionDetails = (id, onSuccess, onError) => {
  return {
    type: SUPER_USER_ROLE_VERSION_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const permissionsRoleList = (onSuccess, onError) => {
  return {
    type: PERMISSION_ROLE_LIST,
    onSuccess,
    onError,
  };
};

export const fetchRoleList = (onSuccess, onError) => {
  return {
    type: ROLE_LIST,
    onSuccess,
    onError,
  };
};
